





























































































































































































































import Vue from "vue";
import { AxiosResponse } from "axios";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
// api
import { getAdunits } from "@/commons/axios/adunit";
import { getPublishers } from "@/commons/axios/publisher";
import * as adunitApi from "@/features/adunitGroup/axios";
// types
import { PublishersAdunitResponse, PublishersResponse } from "@/commons/types";
import { Adunit, SearchParams, Publisher, AdunitGroupResponse } from "@/features/adunitGroup/types";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";
import * as browserUtil from "@/commons/utils/browserUtil";
// component
import DialogCard from "@/commons/components/DialogCard.vue";
import PageTitle from "@/commons/components/PageTitle.vue";
import PcAdunitSelector from "@/features/adunitGroup/components/pc/AdunitSelector.vue";
import MobileAdunitSelector from "@/features/adunitGroup/components/mobile/AdunitSelector.vue";
// enum
import { ReportTypeEnum } from "@/features/analytics/enums/ReportType";

extend("emojiSyntax", {
  validate(value) {
    const emojiRegex = new RegExp(require("emoji-regex"));
    return !emojiRegex.test(value);
  },
});

export default Vue.extend({
  name: "AdunitGroupEditView",
  components: {
    "page-title": PageTitle,
    "dialog-card": DialogCard,
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
    "adunit-selector-pc": PcAdunitSelector,
    "adunit-selector-mobile": MobileAdunitSelector,
  },
  data() {
    return {
      publisherList: [] as Publisher[],
      adunitList: [] as Adunit[],
      adunitGroupName: "" as string,
      selectedPublisherId: 0 as number,
      tmpPublisherId: 0 as number,
      selectedAdunitList: [] as Adunit[],
      selectedAdunitIdList: [] as number[],
      searchName: "" as string,
      pageIndex: 1 as number,
      showChangePublisherDialog: false as boolean,
      showSaveAdunitGroupDialog: false as boolean,
      showDeleteDialog: false as boolean,
      isLoading: false as boolean,
      confirmationDialog: false as boolean,
      canLeave: false as boolean,
      nextPath: { name: "" as string },
      totalAdunit: 0 as number,
      doLogout: false as boolean,
      showUnAuthorizedDialog: false as boolean,
    };
  },
  computed: {
    adunitListCardMinHeight(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
        case "lg":
        case "xl":
        default:
          return 500;
      }
    },
    isNotChrome(): boolean {
      // NOTE: SafariがUA-CHに対応していないので、UAでChrome以外かどうか判定する.
      return browserUtil.isNotChrome();
    },
    isMobileDisplay(): boolean {
      return this.$vuetify.breakpoint.name === "xs";
    },
    modalWidth(): string {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "80%";
        case "sm":
          return "65%";
        case "md":
          return "50%";
        case "lg":
          return "45%";
        case "xl":
          return "35%";
      }
      return "50%";
    },
  },
  watch: {
    selectedPublisherId() {
      if (this.selectedPublisherId !== null) this.getAdunitList();
    },
  },
  async created() {
    this.isLoading = true;
    await getPublishers()
      .then((res: AxiosResponse<PublishersResponse>) => {
        this.publisherList = res.data.publishers;
        if (this.$route.name === "AdunitGroupSetting") {
          this.selectedPublisherId = this.publisherList[0].publisherId;
          this.tmpPublisherId = this.publisherList[0].publisherId;
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
          this.$router.push({ name: "Login" });
        } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
      });
    if (this.$route.name === "AdunitGroupEdit") {
      await adunitApi
        .getAdunitGroupById(Number(this.$route.params.adunitGroupId))
        .then((res: AxiosResponse<AdunitGroupResponse>) => {
          this.adunitGroupName = res.data.adunitGroupName;
          this.selectedPublisherId = res.data.publisherId;
          this.tmpPublisherId = res.data.publisherId;
          this.selectedAdunitList = res.data.adunits;
          this.selectedAdunitIdList = this.selectedAdunitList.map(adunit => adunit.adunitId);
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else if (error.response.status === 403) {
            this.nextPath.name = "AdunitGroup";
            this.showUnAuthorizedDialog = true;
          } else
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adUnitGroups"));
        });
    }
    this.isLoading = false;
  },
  methods: {
    getAdunitList() {
      this.isLoading = true;
      getAdunits({
        reportType: ReportTypeEnum.BI_REPORT.value,
        index: 1,
        publisherId: this.selectedPublisherId,
        name: "",
      })
        .then((res: AxiosResponse<PublishersAdunitResponse>) => {
          this.adunitList = res.data.adunits;
          this.totalAdunit = res.data.total;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adUnits"));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateAdunitList(searchParams: SearchParams) {
      this.isLoading = true;
      getAdunits({
        reportType: ReportTypeEnum.BI_REPORT.value,
        index: searchParams.index,
        publisherId: Number(this.selectedPublisherId),
        name: searchParams.adunitName,
      })
        .then((res: AxiosResponse<PublishersAdunitResponse>) => {
          this.adunitList = res.data.adunits;
          this.totalAdunit = res.data.total;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adUnits"));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitEvent() {
      if (this.selectedAdunitIdList.length === 0) {
        notifyUtil.notifyErrorMessage(this.$t("adUnitGroup.notify.error.emptyAdUnitGroup"));
        return;
      }
      this.showSaveAdunitGroupDialog = true;
    },
    onClickChangePublisherButton() {
      this.tmpPublisherId = this.selectedPublisherId;
      this.searchName = "";
      this.pageIndex = 1;
      this.selectedAdunitList.splice(0);
      this.selectedAdunitIdList.splice(0);
      this.showChangePublisherDialog = false;
    },
    onClickCancelPublisherButton() {
      this.selectedPublisherId = this.tmpPublisherId;
      this.showChangePublisherDialog = false;
    },
    onClickSaveButton() {
      this.isLoading = true;
      if (this.$route.name === "AdunitGroupSetting") {
        adunitApi
          .createAdunitGroup({
            adunitGroupName: this.adunitGroupName,
            adunits: this.selectedAdunitIdList,
            publisherId: this.selectedPublisherId,
          })
          .then(() => {
            notifyUtil.notifySuccessMessage(this.$t("adUnitGroup.notify.success.save"));
            this.canLeave = true;
            this.$router.push({ name: "AdunitGroup" });
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else notifyUtil.notifyErrorMessage(this.$t("adUnitGroup.notify.error.failedSave"));
          })
          .finally(() => {
            this.showSaveAdunitGroupDialog = false;
            this.isLoading = false;
          });
      } else if (this.$route.name === "AdunitGroupEdit") {
        adunitApi
          .updateAdunitGroup({
            adunitGroupId: Number(this.$route.params.adunitGroupId),
            adunitGroupName: this.adunitGroupName,
            adunits: this.selectedAdunitIdList,
            publisherId: this.selectedPublisherId,
          })
          .then(() => {
            notifyUtil.notifySuccessMessage(this.$t("adUnitGroup.notify.success.save"));
            this.canLeave = true;
            this.$router.push({ name: "AdunitGroup" });
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else notifyUtil.notifyErrorMessage(this.$t("adUnitGroup.notify.error.failedSave"));
          })
          .finally(() => {
            this.showSaveAdunitGroupDialog = false;
            this.isLoading = false;
          });
      } else {
        // ここには到達しえないが念の為
        notifyUtil.notifyErrorMessage(this.$t("general.notify.error.failedRequest"));
      }
    },
    onClickDeleteButton() {
      this.isLoading = true;
      adunitApi
        .deleteAdunitGroup(Number(this.$route.params.adunitGroupId))
        .then(() => {
          notifyUtil.notifySuccessMessage(this.$t("adUnitGroup.notify.success.delete"));
          this.canLeave = true;
          this.$router.push({ name: "AdunitGroup" });
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("adUnitGroup.notify.error.delete"));
          }
        })
        .finally(() => {
          this.showDeleteDialog = false;
          this.isLoading = false;
        });
    },
    clickCancelOnDeleteDialog() {
      this.showDeleteDialog = false;
    },
    clickOkOnDialog() {
      this.confirmationDialog = false;
      this.showUnAuthorizedDialog = false;
      this.canLeave = true;
      
      if (this.doLogout) {
        this.$emit("logout");
      } else {
        this.$router.push(this.nextPath);
      }
    },
    clickCancelOnDialog() {
      this.confirmationDialog = false;
      this.doLogout = false;
    },
    removeAdunit(targetAdunitId: number) {
      this.selectedAdunitList = this.selectedAdunitList.filter(
        (adunit: Adunit) => adunit.adunitId !== targetAdunitId
      );
      this.selectedAdunitIdList = this.selectedAdunitIdList.filter(
        (adunitId: number) => adunitId !== targetAdunitId
      );
    },
    checkMove() {
      this.doLogout = true;
      this.confirmationDialog = true;
    },
  },

  /**
   * このコンポーネントから離れる時に発火する.
   * 遷移フラグが立っているかChrome以外のブラウザの場合はそのまま遷移させ、遷移フラグが立っていなければ遷移を中断し確認ダイアログを表示してから遷移する.
   */
  beforeRouteLeave(to, from, next) {
    if (this.canLeave || this.isNotChrome) {
      next();
      return;
    }
    this.confirmationDialog = true;
    this.nextPath.name = String(to.name);
    next(false);
  },
});
